export enum TurnPortfoliosSortBy {
  VEHICLE_ASC = 'Vehicle Ascending',
  VEHICLE_DESC = 'Vehicle Descending',
  EST_MILEAGE_ASC = 'Est. Mileage Ascending',
  EST_MILEAGE_DESC = 'Est. Mileage Descending',
  DAYS_ON_LOT_ASC = 'Days on Lot Ascending',
  DAYS_ON_LOT_DESC = 'Days on Lot Descending',
  PRICE_ASC = 'Price Ascending',
  PRICE_DESC = 'Price Descending',
  CUSTOMER_MATCHES_ASC = '# of Customer Matches Ascending',
  CUSTOMER_MATCHES_DESC = '# of Customer Matches Descending',
}
